var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerplexity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1fb8cd",
    d: "M12 2L4 7v10l8 5 8-5V7l-8-5zm6 14.2l-6 3.75-6-3.75V7.8l6-3.75 6 3.75v8.4zM11 7h2v10h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerplexity);
export default __webpack_public_path__ + "static/media/perplexity.f557fd99e8578043934d01ac2f7a0a93.svg";
export { ForwardRef as ReactComponent };